import * as tslib_1 from "tslib";
import { NgZone, OnInit } from '@angular/core';
import * as _ from "lodash";
import * as moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { AlertComponent } from '../alert/alert.component';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import { PopuptableComponent } from '../popuptable/popuptable.component';
import { AlertpopuptableComponent } from '../alertpopuptable/alertpopuptable.component';
// @ts-ignore
import ApexCharts from 'apexcharts';
import { RenewalWindowComponent } from '../renewal-window/renewal-window.component';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(zone, _dashboardService, globalService, reportService, trnsfrmr, sitemanagerService, http, route, ngxLoader, router, matDialog) {
        this.zone = zone;
        this._dashboardService = _dashboardService;
        this.globalService = globalService;
        this.reportService = reportService;
        this.trnsfrmr = trnsfrmr;
        this.sitemanagerService = sitemanagerService;
        this.http = http;
        this.route = route;
        this.ngxLoader = ngxLoader;
        this.router = router;
        this.matDialog = matDialog;
        /* model */
        this.canvasWidth = 200;
        this.needleValue = 0;
        this.centralLabel = '';
        this.options = {
            hasNeedle: true,
            needleColor: 'black',
            needleUpdateSpeed: 1000,
            arcColors: ['red', 'orange', 'green'],
            arcDelimiters: [30, 50],
            rangeLabel: ['0', '100'],
            needleStartValue: 0,
        };
        this.textColor = "#FFFFFF";
        this.selectedCountry = null;
        this.amcexpiredtransformer = [];
        this.selectedState = null;
        this.selectedCity = null;
        this.selectedZone = null;
        this.selectedLocation = null;
        this.selectedTransformer = null;
        this.ageTransformer = null;
        this.ageTransformerArray = null;
        this.windingTempArray = [];
        this.OilLevelArray = [];
        this.humidityArray = [];
        this.PFArray = [];
        this.harmonicsArray = [];
        this.loadArray = [];
        this.ratedLoadArray = [];
        this.vunbalanceArray = [];
        this.healthIndexArray = [];
        this.ratedLoadValue = null;
        this.imgPath = "../assets/images/black_transformer.png";
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
        this.calculatedWindingTemprature = 0;
        this.countryList = [];
        this.stateList = [];
        this.cityList = [];
        this.zoneList = [];
        this.locationList = [];
        this.transformerList = [];
        this.healthIndex = [];
        this.iUnbalanceArray = [];
        this.weatherData = null;
        this.selectedTransformerForWeather = null;
        this.selectedTransformerForHealth = null;
        this.timeOptions = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
        this.filter = {};
        this.oilTempsum = 0;
        this.OilTempArray = [];
        this.transformerDataForHealthIndex = [];
        this.LoadPercentages = [];
        this.muteButton = "assets/images/unmute.png";
        this.muteFlag = 0;
        this.batteryStatusImgUrl = "assets/images/fullbattery.png";
        this.cap = {
            radius: 5,
            border: {
                color: 'red',
                width: 3
            }
        };
        this.labelStyle = {
            format: '{value}°'
        };
        this.labelStyles = {
            format: '{value}%'
        };
        this.durationList = [
            { id: 1, name: 'Today' },
            { id: 2, name: 'Yesterday' },
            { id: 3, name: 'This Week' },
            { id: 4, name: 'This Month' },
            { id: 5, name: 'Last Month' },
            { id: 6, name: 'Custom' }
        ];
        this.selectedDuration = null;
        this.selectedDurationAlert = null;
        this.parameterList = [
            { name: 'All', value: 'all' },
            { name: 'Oil Temperature', value: 'apOiltemperature' },
            { name: 'Winding Temperature', value: 'apWindingtemperature' },
            { name: 'Overload', value: 'apOverload' },
            { name: 'Underload', value: 'apUnderload' },
            { name: 'Iunbalance', value: 'apIunbalance' },
            { name: 'Vunbalance', value: 'apVunbalance' },
            { name: 'Lowvolt', value: 'apLowvolt' },
            { name: 'Low Powerfactor', value: 'apLowPowerfactor' },
            { name: 'Oil Level', value: 'apOillevel' },
        ];
        this.selectedParameter = this.parameterList[0];
        this.redTransformerPath = '../assets/images/red_transformer.png';
        this.greenTransformerPath = '../assets/images/green_transformer.png';
        this.blackTransformerPath = '../assets/images/black_transformer.png';
        this.dataPoints = [{ lat: '20.10009154', lng: '73.011800995' }, { lat: '20.09894655', lng: '73.0174298' }];
        this.dataLoadProfile = [];
        this.graphLoadProfile = {
            layout: {
                width: 500, height: 290,
                xaxis: {
                    title: {
                        text: 'Transformer Id',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000',
                        }
                    },
                },
                yaxis: {
                    title: {
                        text: 'Load Percentage',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000'
                        }
                    }
                }
            },
            config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
        };
        this.dataAlertCount = [];
        this.graphAlertCount = {
            layout: {
                width: 500, height: 290,
                xaxis: {
                    title: {
                        text: 'Date',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000',
                        }
                    },
                },
                yaxis: {
                    title: {
                        text: 'No. of Alerts',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000'
                        }
                    }
                }
            },
            config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
        };
        this.dataTransformerAlert = [];
        this.allTransformers = [];
        this.graphTransformerAlert = {
            layout: {
                width: 500, height: 290,
                xaxis: {
                    title: {
                        text: 'Transformer ID',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000',
                        }
                    },
                },
                yaxis: {
                    title: {
                        text: 'No. of Alerts',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000'
                        }
                    }
                }
            },
            config: { displaylogo: false, responsive: true, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
        };
        this.kvaData = null;
        this.kwData = null;
        this.kwhData = null;
        this.readings = [];
        this.mapData = [];
        this.transformerTile = null;
        this.latestAlertsArray = [];
        this.showPopup = false;
        this.audio = new Audio();
        this.jiouser = false;
        this.completeMaintenanceCount = 0;
        this.pendingMaintenanceCount = 0;
        this.completeMaintenanceData = 0;
        this.pendingMaintenanceData = 0;
        this.maxDemand = 0;
        this.maxDemandValue = 0;
        this.averageDemand = 0;
        this.warningDataArray = [];
        this.socket = new WebSocket('wss://api.trafobola.com');
    }
    DashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.currentUserData.userid == 283) {
            this.jiouser = true;
        }
        this.globalService.countrySelection(this.currentUserData.countryid).subscribe(function (response) {
            _this.countryCode = response.result[0].code;
            _this.ngxLoader.startLoader('healthIndexArray');
            _this.globalService.golbalMaster('country').subscribe(function (response) {
                _this.countryList = response.result;
                _this.selectedCountry = _.find(_this.countryList, function (o) {
                    return o.code === _this.countryCode;
                });
                _this.countrySelection();
                _this.getLatLang();
                _this.getMaintenancePlanningData();
                _this.getHealthIndex();
            });
        });
        this.timeFilter = 'Today';
    };
    DashboardComponent.prototype.ngOnDestroy = function () {
        console.log('Dashboard destroyed, stopping audio');
        if (this.socket) {
            this.socket.close();
        }
        this.audio.pause();
        this.audio.currentTime = 0;
    };
    DashboardComponent.prototype.transformerStatusGraph = function () {
        var _this = this;
        console.log("abcd ", this.transformerTile);
        var seriesData = [this.transformerTile.onlineTransformer, this.transformerTile.offlineTransformer, this.transformerTile.alertTransformer, this.transformerTile.normalTransformer];
        var total = seriesData.reduce(function (a, b) { return a + b; }, 0);
        var options = {
            series: seriesData,
            chart: {
                height: "100%",
                type: 'donut',
                events: {
                    legendClick: function (chartContext, seriesIndex) {
                        var legendName = options.labels[seriesIndex];
                        _this.popupTable(legendName, '');
                    }
                },
            },
            plotOptions: {
                pie: {
                    startAngle: -90,
                    endAngle: 270,
                    donut: {
                        size: '65%',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                fontSize: '2vh',
                                color: this.textColor,
                                offsetY: -10,
                            },
                            value: {
                                show: true,
                                fontSize: '2.5vh',
                                fontWeight: 600,
                                color: this.textColor,
                                offsetY: -1,
                                formatter: function () { return "" + _this.transformerTile.totalTransformer; },
                            },
                            total: {
                                show: true,
                                label: 'Total',
                                fontSize: '1.5vh',
                                fontWeight: 600,
                                color: this.textColor,
                                formatter: function () { return "" + _this.transformerTile.totalTransformer; },
                            },
                        },
                    },
                },
            },
            colors: ["#008000", "#808080", "#ff0000", "#00ffec"],
            labels: ["online", "offline", "alert", "normal"],
            dataLabels: {
                enabled: false,
            },
            fill: {
                type: 'gradient',
            },
            legend: {
                position: 'right',
                formatter: function (val, opts) {
                    return "<span style=\"font-weight: bolder; cursor: pointer;\">" + val + " :<b style=\"font-size:2vh;\"> " + opts.w.globals.series[opts.seriesIndex] + "</b></span>";
                },
                labels: {
                    useSeriesColors: true,
                },
            },
            title: {
                text: 'Transformer Status',
                align: 'center',
                style: {
                    color: this.textColor
                }
            },
        };
        var chart = new ApexCharts(document.querySelector("#transformerStatus"), options);
        chart.render();
    };
    DashboardComponent.prototype.deviceStatus = function (connected, disconnected) {
        var _this = this;
        console.log("abcd ", connected);
        var seriesData = [connected, disconnected];
        var options = {
            series: seriesData,
            chart: {
                height: "100%",
                type: 'pie',
                events: {
                    legendClick: function (chartContext, seriesIndex) {
                        var legendName = options.labels[seriesIndex];
                        _this.popupTable(legendName, _this.deviceConnectionStatus);
                    }
                },
            },
            colors: ["#008000", "#808080"],
            labels: ["Connected", "Disconnected"],
            dataLabels: {
                enabled: false,
            },
            fill: {
                type: 'gradient',
            },
            legend: {
                position: 'right',
                formatter: function (val, opts) {
                    // Add the image only for "disconnected" legend item
                    if (val.toLowerCase() === "disconnected") {
                        return "<span style=\"font-weight: bolder; cursor: pointer;\">\n            " + val + " :<b style=\"font-size:2vh;\"> " + opts.w.globals.series[opts.seriesIndex] + "</b><br>\n            <img src=\"assets/images/connection.gif\" height=\"40\" width=60\" style=\"margin-left: 20%;margin-top:10%\">\n          </span>";
                    }
                    return "<span style=\"font-weight: bolder; cursor: pointer;\">\n          " + val + " :<b style=\"font-size:2vh;\"> " + opts.w.globals.series[opts.seriesIndex] + "</b>\n        </span>";
                },
                labels: {
                    useSeriesColors: true,
                },
            },
            title: {
                text: 'Last 2 Days Connection Status',
                align: 'center',
                style: {
                    color: this.textColor
                }
            },
        };
        var chart = new ApexCharts(document.querySelector("#deviceStatus"), options);
        chart.render();
    };
    DashboardComponent.prototype.alertStatus = function () {
        var _this = this;
        var alertArray = ["apOiltemperature", "apWindingtemperature", "apVunbalance", "apIunbalance", "apLowvolt", "apHighvolt", "apLowPowerfactor", "apUnderload", "apOverload"];
        // Initialize an object to store the total count for each alert, setting all counts to 0 initially
        var totalAlertCount = {};
        alertArray.forEach(function (alert) {
            totalAlertCount[alert] = 0; // Initialize each alert parameter with a count of 0
        });
        // Loop through each transformer in overallTransformerData.result
        this.overallTransformerData.result.forEach(function (element) {
            // Loop through each alert in the current transformer
            element.alert.forEach(function (alertItem) {
                // Check if the alert's parametername is in the alertArray
                if (alertArray.includes(alertItem.parametername)) {
                    // Increment the count for that parameter
                    totalAlertCount[alertItem.parametername]++;
                }
            });
        });
        // After processing all transformers, log the total alert count for each parameter
        console.log("Total alert counts across all transformers:", totalAlertCount);
        var alertMapping = {
            apOiltemperature: "Oil Temp",
            apWindingtemperature: "Wind Temp",
            apVunbalance: "V Unbalance",
            apIunbalance: "I Unbalance",
            apLowvolt: "Low Volt",
            apHighvolt: "High Volt",
            apLowPowerfactor: "Low PF",
            apUnderload: "Underload",
            apOverload: "Overload"
        };
        var options = {
            series: [{
                    name: "Alerts",
                    data: [
                        { x: alertMapping["apOiltemperature"], y: totalAlertCount.apOiltemperature, alertName: "apOiltemperature" },
                        { x: alertMapping["apWindingtemperature"], y: totalAlertCount.apWindingtemperature, alertName: "apWindingtemperature" },
                        { x: alertMapping["apVunbalance"], y: totalAlertCount.apVunbalance, alertName: "apVunbalance" },
                        { x: alertMapping["apIunbalance"], y: totalAlertCount.apIunbalance, alertName: "apIunbalance" },
                        { x: alertMapping["apLowvolt"], y: totalAlertCount.apLowvolt, alertName: "apLowvolt" },
                        { x: alertMapping["apHighvolt"], y: totalAlertCount.apHighvolt, alertName: "apHighvolt" },
                        { x: alertMapping["apLowPowerfactor"], y: totalAlertCount.apLowPowerfactor, alertName: "apLowPowerfactor" },
                        { x: alertMapping["apUnderload"], y: totalAlertCount.apUnderload, alertName: "apUnderload" },
                        { x: alertMapping["apOverload"], y: totalAlertCount.apOverload, alertName: "apOverload" }
                    ]
                }],
            chart: {
                type: 'bar',
                height: "100%",
                events: {
                    dataPointSelection: function (event, chartContext, config) {
                        var selectedData = config.w.config.series[config.seriesIndex].data[config.dataPointIndex];
                        var alertName = selectedData.alertName;
                        _this.popupTable(alertName, 'alertDataSelected'); // Call the function with the correct parameters
                    }
                },
                toolbar: {
                    show: false
                },
                minBarHeight: 10,
            },
            colors: ['#FF6347', '#1E90FF', '#32CD32', '#FFD700', '#FF4500', '#8A2BE2', '#20B2AA', '#FF1493', '#FF8C00'],
            xaxis: {
                type: 'category',
                labels: {
                    style: {
                        colors: this.textColor,
                        fontSize: '1.5vh'
                    },
                    rotate: 0,
                },
            },
            yaxis: {
                show: false,
                labels: {
                    show: false
                },
            },
            title: {
                text: 'Alert Status',
                align: 'center',
                style: {
                    color: this.textColor
                }
            },
            grid: {
                show: false
            },
            tooltip: {
                style: {
                    color: "#1E90FF"
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 10,
                    columnWidth: '80%',
                    dataLabels: {
                        position: 'top',
                        style: {
                            colors: ['#000000'] // Color of the value text (make it stand out)
                        }
                    }
                }
            }
        };
        var chart = new ApexCharts(document.querySelector("#alertStatus"), options);
        chart.render();
    };
    DashboardComponent.prototype.healthStatus = function (average, unhealthy, healthy) {
        var _this = this;
        console.log("abcd ", this.transformerTile);
        var seriesData = [healthy, average, unhealthy];
        var options = {
            series: seriesData,
            chart: {
                height: "100%",
                type: 'pie',
                events: {
                    legendClick: function (chartContext, seriesIndex) {
                        var legendName = options.labels[seriesIndex];
                        _this.popupTable(legendName, '');
                    }
                },
            },
            colors: ["#3aff00", "#ffdc2f", "#ff0000"],
            labels: ["Healthy", "Average", "Unhealthy"],
            dataLabels: {
                enabled: false,
            },
            fill: {
                type: 'gradient',
            },
            legend: {
                position: 'right',
                formatter: function (val, opts) {
                    // Add the image only for "disconnected" legend item
                    return "<span style=\"font-weight: bolder; cursor: pointer;\">\n          " + val + " :<b style=\"font-size:2vh;\"> " + opts.w.globals.series[opts.seriesIndex] + "</b>\n        </span>";
                },
                labels: {
                    useSeriesColors: true,
                },
            },
            title: {
                text: 'Health Status Of Transformers',
                align: 'center',
                style: {
                    color: this.textColor,
                }
            },
        };
        var chart = new ApexCharts(document.querySelector("#healthStatus"), options);
        chart.render();
    };
    DashboardComponent.prototype.loadAverageGraph = function (average) {
        var options = {
            series: [average],
            chart: {
                height: '100%',
                padding: 0,
                type: 'radialBar',
                offsetY: 0
            },
            plotOptions: {
                radialBar: {
                    startAngle: -160,
                    endAngle: 160,
                    dataLabels: {
                        name: {
                            fontSize: '1.5vh',
                            color: '#00ffbf',
                            offsetY: '-5%'
                        },
                        value: {
                            offsetY: 0,
                            fontSize: '2.5vh',
                            color: '#00ffbf',
                            formatter: function (val) {
                                return val + "%";
                            }
                        }
                    }
                }
            },
            fill: {
                colors: ['#00ffbf'],
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    shadeIntensity: 1,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                },
            },
            stroke: {
                dashArray: 2
            },
            labels: ['Load'],
            grid: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };
        var chart = new ApexCharts(document.querySelector("#loadAverage"), options);
        chart.render();
    };
    DashboardComponent.prototype.peakLoadGraph = function (peakLoad) {
        var options = {
            series: [peakLoad],
            chart: {
                height: '100%',
                padding: 0,
                type: 'radialBar',
                offsetY: 0
            },
            plotOptions: {
                radialBar: {
                    startAngle: -160,
                    endAngle: 160,
                    dataLabels: {
                        name: {
                            fontSize: '1.5vh',
                            color: '#ff2f2f',
                            offsetY: '-10%'
                        },
                        value: {
                            offsetY: 0,
                            fontSize: '2.5vh',
                            color: '#ff2f2f',
                            formatter: function (val) {
                                return val + "%";
                            }
                        }
                    }
                }
            },
            fill: {
                colors: ['#ff2f2f'],
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    shadeIntensity: 1,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                },
            },
            stroke: {
                dashArray: 0
            },
            labels: ['Load'],
            grid: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };
        var chart = new ApexCharts(document.querySelector("#peakLoad"), options);
        chart.render();
    };
    DashboardComponent.prototype.alertCheck = function (data, a) {
        console.log(data);
    };
    DashboardComponent.prototype.fetchLatestAlertData = function (transformerIdsArray) {
        var _this = this;
        //{userid:this.currentUserData.userid,roleid:this.currentUserData.roleid}
        this.audio.src = "assets/sound/alertsound.mp3";
        this.socket.onopen = function () { return console.log('✅ WebSocket connected'); };
        this.socket.onerror = function (e) { return console.error('❌ WebSocket error:', e); };
        this.socket.onmessage = function (event) {
            _this.zone.runOutsideAngular(function () {
                try {
                    var msg = JSON.parse(event.data);
                    var newArray_1 = [];
                    if (msg.type == "alertQueue") {
                        msg.data.forEach(function (data) {
                            newArray_1 = [];
                            if (transformerIdsArray.includes(data.transformerid)) {
                                if (data.parametername != 'apOillevel') {
                                    data.gparametervalue = data.gparametervalue;
                                }
                                newArray_1.push(data);
                                _this.latestAlertsArray.push(data);
                                if (_this.dialogRefas && _this.dialogRefas.componentInstance) {
                                    _this.dialogRefas.componentInstance.data.newData = data;
                                }
                            }
                        });
                        if (_this.currentUserData.userid == 196 && newArray_1.length > 0) {
                            _this.audio.load();
                            _this.audio.play();
                        }
                    }
                }
                catch (err) {
                    console.error('❌ Error parsing data:', err);
                }
            });
        };
    };
    DashboardComponent.prototype.OilTempGraph = function (value) {
        var options = {
            series: [value],
            chart: {
                height: '100%',
                width: '100%',
                padding: 0,
                type: 'radialBar',
                offsetY: 0
            },
            title: {
                text: 'Oil Temperature',
                align: 'center',
                style: {
                    fontWeight: 'bold',
                    color: '#333'
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -160,
                    endAngle: 160,
                    dataLabels: {
                        name: {
                            fontSize: '70%',
                            color: '#964B00',
                            offsetY: '-5%'
                        },
                        value: {
                            offsetY: 0,
                            fontSize: '100%',
                            color: 'black',
                            formatter: function (val) {
                                return val + "°C";
                            }
                        }
                    }
                }
            },
            fill: {
                colors: ['#f75431'],
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    shadeIntensity: 1,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 0.1,
                },
            },
            stroke: {
                dashArray: 3
            },
            labels: ['Oil Temp'],
            grid: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };
        this.chart1 = new ApexCharts(document.querySelector("#oilTemp"), options);
        this.chart1.render();
    };
    DashboardComponent.prototype.comparisionGraph = function () {
        var options = {
            series: [{
                    name: 'Oil Temp',
                    data: []
                }, {
                    name: 'Winding Temp',
                    data: []
                }],
            chart: {
                height: "100%",
                width: "100%",
                type: 'area'
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            title: {
                text: '.',
                align: 'left'
            },
            xaxis: {
                type: 'DateTime',
                tickAmount: 2.2,
                tickPlacement: 'between',
                intervalType: 'Hours',
                labels: {
                    show: true,
                    style: {
                        colors: 'black',
                        fontWeight: 'bold'
                    },
                    rotate: 0,
                },
                categories: []
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                floating: true,
                offsetY: -25,
                offsetX: -5
            },
        };
        this.comparision = new ApexCharts(document.querySelector("#comparision"), options);
        this.comparision.render();
    };
    DashboardComponent.prototype.WindTempGraph = function () {
        var options = {
            series: [0],
            chart: {
                height: '100%',
                //width:'100%',
                padding: 0,
                type: 'radialBar',
                offsetY: 0
            },
            title: {
                text: 'Winding Temperature',
                align: 'center',
                style: {
                    fontWeight: 'bold',
                    color: '#333'
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -160,
                    endAngle: 160,
                    dataLabels: {
                        name: {
                            fontSize: '70%',
                            color: '#964B00',
                            offsetY: '-5%'
                        },
                        value: {
                            offsetY: 0,
                            fontSize: '100%',
                            color: 'black',
                            formatter: function (val) {
                                return val + "°C";
                            }
                        }
                    }
                }
            },
            fill: {
                colors: ['#FF4500'],
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    shadeIntensity: 1,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 0.1,
                },
            },
            stroke: {
                dashArray: 1
            },
            labels: ['Winding Temp'],
            grid: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };
        this.chart2 = new ApexCharts(document.querySelector("#windTemp"), options);
        this.chart2.render();
    };
    DashboardComponent.prototype.loadperGraph = function () {
        var options = {
            series: [0],
            chart: {
                height: '100%',
                width: '100%',
                padding: 0,
                type: 'radialBar',
                offsetY: 0
            },
            title: {
                text: 'Load Percentege',
                align: 'center',
                style: {
                    fontWeight: 'bold',
                    color: '#333'
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -160,
                    endAngle: 160,
                    dataLabels: {
                        name: {
                            fontSize: '70%',
                            color: '#964B00',
                            offsetY: '-5%'
                        },
                        value: {
                            offsetY: 0,
                            fontSize: '100%',
                            color: 'black',
                            formatter: function (val) {
                                return val + " %";
                            }
                        }
                    }
                }
            },
            fill: {
                colors: ['#0B5345'],
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    shadeIntensity: 1,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 0.1,
                },
            },
            stroke: {
                dashArray: 5
            },
            labels: ['Load %'],
            grid: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };
        this.chart3 = new ApexCharts(document.querySelector("#loadper"), options);
        this.chart3.render();
    };
    DashboardComponent.prototype.oilLevel = function (value) {
        var options = {
            series: [value],
            chart: {
                height: '100%',
                width: '100%',
                type: 'radialBar',
                offsetY: 0
            },
            title: {
                text: 'Oil Level',
                align: 'center',
                style: {
                    fontWeight: 'bold',
                    color: '#333'
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -160,
                    endAngle: 160,
                    dataLabels: {
                        name: {
                            fontSize: '70%',
                            color: '#964B00',
                            offsetY: '-5%'
                        },
                        value: {
                            offsetY: 0,
                            fontSize: '100%',
                            color: 'black',
                            formatter: function (val, opts) {
                                return 'No Data';
                            }
                        }
                    }
                }
            },
            colors: ['blue'],
            stroke: {
                dashArray: 0
            },
            labels: ['Oil Level'],
            grid: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };
        this.oilLevelGraphObject = new ApexCharts(document.querySelector("#oilLevel"), options);
        this.oilLevelGraphObject.render();
    };
    DashboardComponent.prototype.lugTemp = function () {
        var options = {
            series: [0, 0, 0],
            chart: {
                height: 'auto',
                width: '100%',
                type: 'radialBar',
            },
            title: {
                text: 'Lug Temperature',
                align: 'center',
                style: {
                    fontWeight: 'bold',
                    color: '#333'
                }
            },
            plotOptions: {
                radialBar: {
                    offsetY: 0,
                    startAngle: 0,
                    endAngle: 270,
                    hollow: {
                        margin: 5,
                        size: '30%',
                        background: 'transparent',
                        image: undefined,
                    },
                    dataLabels: {
                        name: {
                            show: false,
                        },
                        value: {
                            show: false,
                        }
                    }
                }
            },
            colors: ['#FF0101', '#D3E129', '#019BFF'],
            labels: ['R-Phase', 'Y-Phase', 'B-Phase'],
            legend: {
                show: true,
                floating: true,
                fontSize: '12%',
                position: 'left',
                //offsetX: 20,
                offsetY: 27,
                labels: {
                    useSeriesColors: true,
                },
                markers: {
                    size: 0
                },
                formatter: function (seriesName, opts) {
                    return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "°C";
                },
                itemMargin: {
                    vertical: 0
                },
                grid: {
                    padding: {
                        top: 0,
                        right: '2%',
                        bottom: 0,
                        left: 0
                    }
                }
            },
            stroke: {
                dashArray: 0
            },
            responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            show: false
                        }
                    }
                }]
        };
        this.lugTempGraphObject = new ApexCharts(document.querySelector("#lugTemp"), options);
        this.lugTempGraphObject.render();
    };
    DashboardComponent.prototype.healthIndexData = function () {
        var options = {
            series: [0],
            chart: {
                height: '100%',
                width: '100%',
                type: 'radialBar',
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -135,
                    endAngle: 225,
                    hollow: {
                        margin: 0,
                        size: '70%',
                        background: '#fff',
                        image: undefined,
                        imageOffsetX: 0,
                        imageOffsetY: 0,
                        position: 'front',
                        dropShadow: {
                            enabled: true,
                            top: 3,
                            left: 0,
                            blur: 4,
                            opacity: 0.24
                        }
                    },
                    track: {
                        background: '#fff',
                        strokeWidth: '67%',
                        margin: 0,
                        dropShadow: {
                            enabled: true,
                            top: -3,
                            left: 0,
                            blur: 4,
                            opacity: 0.35
                        }
                    },
                    dataLabels: {
                        show: true,
                        name: {
                            offsetY: 0,
                            show: true,
                            color: '#596271',
                            fontSize: '80%'
                        },
                        value: {
                            formatter: function (val) {
                                return val + "%";
                            },
                            color: 'green',
                            fontSize: '130%',
                            show: true,
                        }
                    }
                }
            },
            fill: {
                colors: ["#800020"],
            },
            stroke: {
                lineCap: 'round'
            },
            labels: ['Health Index'],
        };
        this.healthIndexObject = new ApexCharts(document.querySelector("#healthIndex"), options);
        this.healthIndexObject.render();
    };
    DashboardComponent.prototype.getHealthIndex = function () {
        var _this = this;
        this._dashboardService.gethealthSatus({
            userid: this.currentUserData.userid,
            roleid: this.currentUserData.roleid
        }).subscribe(function (response) {
            console.log("health response", response);
            var transformers = [];
            if (_this.currentUserData.roleid !== 1) {
                // Non-admin → only Active transformers
                transformers = response.result.filter(function (v) { return v.amc_status === "Active"; });
            }
            else {
                // Admin → use all transformers
                transformers = response.result;
            }
            _this.averageHealth = transformers
                .filter(function (v) { return v.health_status === "Average"; })
                .map(function (v) { return v.transformerid; });
            _this.Unhealthy = transformers
                .filter(function (v) { return v.health_status === "Unhealthy"; })
                .map(function (v) { return v.transformerid; });
            _this.Healthy = transformers
                .filter(function (v) { return v.health_status === "Healthy"; })
                .map(function (v) { return v.transformerid; });
            _this.healthStatus(_this.averageHealth.length, _this.Unhealthy.length, _this.Healthy.length);
        });
    };
    DashboardComponent.prototype.getMaintenancePlanningData = function () {
        var _this = this;
        this.trnsfrmr.getMaintenancePlanningData({ userid: this.currentUserData.userid }).subscribe(function (response) {
            console.log("Maintenance data", response);
            if (response.data.length > 0) {
                _this.completeMaintenanceData = response.data.filter(function (value) { return value.status == "Complete"; }).map(function (data) { return data.transformerid; });
                _this.pendingMaintenanceData = response.data.filter(function (value) { return value.status == "Pending"; }).map(function (data) { return data.transformerid; });
                _this.completeMaintenanceCount = _this.completeMaintenanceData.length;
                _this.pendingMaintenanceCount = _this.pendingMaintenanceData.length;
            }
        });
    };
    DashboardComponent.prototype.getLatLang = function () {
        var countryid = this.currentUserData.countryid;
        if (countryid == 100) {
            this.lat1 = 20.5937;
            this.lng1 = 78.9629;
        }
        else if (countryid == 162) {
            this.lat1 = 9.0820;
            this.lng1 = 8.6753;
        }
        else if (countryid == 232) {
            this.lat1 = 40.147844308078014;
            this.lng1 = -101.23596925926525;
        }
        else if (countryid == 111) {
            this.lat1 = 36.52430154315737;
            this.lng1 = 139.42371318237787;
        }
    };
    DashboardComponent.prototype.openAlertBox = function () {
        var dialogRef;
        var dialogConfig = new MatDialogConfig();
        dialogRef = this.matDialog.open(AlertComponent, {
            autoFocus: false,
            height: '600px', width: '700px', data: { "details": "", "action": "Add" }, panelClass: 'custom-modalbox'
        });
        dialogRef.updatePosition({ top: '50px', right: '10px' });
    };
    DashboardComponent.prototype.filtertransformerPayload = function () {
        var payloadtogetTransformer = {
            "countryid": this.selectedCountry ? this.selectedCountry.id : null,
            "stateid": this.selectedState ? this.selectedState.id : null,
            "cityid": this.selectedCity ? this.selectedCity.id : null,
            "zoneid": this.selectedZone ? this.selectedZone.id : null,
            "locationid": this.selectedLocation ? this.selectedLocation.id : null,
            "transformerid": this.selectedTransformer ? this.selectedTransformer.transformerid : null,
        };
        return payloadtogetTransformer;
    };
    DashboardComponent.prototype.getListofTransformerInitial = function () {
        var _this = this;
        var payloadtogetTransformer = {
            "countryid": this.selectedCountry ? this.selectedCountry.id : null,
            "stateid": null,
            "cityid": null,
            "zoneid": null,
            "locationid": null,
            "transformerid": null,
        };
        this.globalService.getfilteredTransformers(JSON.stringify(payloadtogetTransformer), localStorage.getItem('userData')).subscribe(function (response) {
            if (response && response.code === '1' && response.result.length > 0) {
                _this.transformerList = response.result;
                _this.transformerList.map(function (e) {
                    e.label = e.transformerid + "[ " + e.sitename + " ]";
                });
            }
        });
    };
    DashboardComponent.prototype.countrySelection = function () {
        var _this = this;
        this.stateList = [];
        this.cityList = [];
        this.zoneList = [];
        this.locationList = [];
        this.filteredTransformers();
        if (this.selectedCountry) {
            this.globalService.getStateList(this.selectedCountry).subscribe(function (response) {
                if (response && response.code === '1') {
                    _this.stateList = response.result;
                }
            });
        }
    };
    DashboardComponent.prototype.stateSelection = function () {
        var _this = this;
        this.cityList = [];
        this.zoneList = [];
        this.locationList = [];
        if (this.selectedState) {
            this.globalService.getCityList(this.selectedState).subscribe(function (response) {
                if (response && response.code === '1') {
                    _this.cityList = response.result;
                }
            });
        }
        else {
            this.selectedCity = null;
            this.selectedZone = null;
            this.selectedLocation = null;
        }
        this.filteredTransformers();
    };
    DashboardComponent.prototype.citySelection = function () {
        var _this = this;
        this.zoneList = [];
        this.locationList = [];
        if (this.selectedCity) {
            this.globalService.getZoneList(this.selectedCity).subscribe(function (response) {
                if (response && response.code === '1') {
                    _this.zoneList = response.result;
                }
            });
        }
        else {
            this.selectedZone = null;
            this.selectedLocation = null;
        }
        this.filteredTransformers();
    };
    DashboardComponent.prototype.zoneSelection = function () {
        var _this = this;
        this.locationList = [];
        if (this.selectedZone) {
            this.globalService.getSiteLocationList(this.selectedZone).subscribe(function (response) {
                if (response && response.code === '1') {
                    _this.locationList = response.result;
                }
            });
        }
        else {
            this.selectedLocation = null;
        }
        this.filteredTransformers();
    };
    DashboardComponent.prototype.locationSelection = function () {
        this.filteredTransformers();
    };
    DashboardComponent.prototype.transformerSelection = function () {
        this.filteredTransformers();
    };
    DashboardComponent.prototype.onMouseOver = function (infoWindow, gm) {
        if (gm.lastOpen && gm.lastOpen.isOpen) {
            gm.lastOpen.close();
        }
        gm.lastOpen = infoWindow;
        infoWindow.open();
    };
    DashboardComponent.prototype.transformerClicked = function (data) {
        console.log("data++", data);
        //data = 'T-1152';
        this.router.navigate(['/report'], { queryParams: { transformerId: data.transformerid } });
    };
    DashboardComponent.prototype.filteredTransformers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var temptransformerList, deviceList, payloadtogetTransformer, userData;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ngxLoader.startLoader('dashboard');
                        temptransformerList = [];
                        deviceList = [];
                        this.kvaData = null;
                        this.kwData = null;
                        this.kwhData = null;
                        payloadtogetTransformer = this.filtertransformerPayload();
                        console.log("filtered response===payloadtogetTransformer==========>", localStorage.getItem('userData'));
                        return [4 /*yield*/, localStorage.getItem('userData')];
                    case 1:
                        userData = _a.sent();
                        this.globalService.getfilteredTransformers(JSON.stringify(payloadtogetTransformer), userData).subscribe(function (response) {
                            console.log("user Data===", response);
                            if (response && response.code == '1' && response.result.length > 0) {
                                _this.ngxLoader.stopLoader('dashboard');
                                console.log("filtered response=============>", response.result[0]);
                                _this.allTransformers = response.result;
                                var tempdata = response.result;
                                if (_this.currentUserData.roleid !== 1) {
                                    console.log("Not Super Admin");
                                    var hasActive = tempdata.some(function (t) { return t.amc_status === "Active"; });
                                    _this.amcexpiredtransformer = tempdata
                                        .filter(function (t) { return t.amc_status === "Expired"; })
                                        .map(function (t) { return t.transformerid; });
                                    _this.getLastUpdatedAlertsData();
                                    if (hasActive) {
                                        _this.transformerList = tempdata.filter(function (t) { return t.amc_status === "Active"; });
                                    }
                                    else {
                                        _this.transformerList = tempdata;
                                    }
                                }
                                else {
                                    _this.transformerList = tempdata;
                                }
                                _this.transformerList.map(function (e) {
                                    e.label = e.transformerid + "[ " + e.sitename + " ]";
                                });
                                for (var i = 0; i < _this.transformerList.length; i++) {
                                    temptransformerList.push(_this.transformerList[i].transformerid);
                                    deviceList.push(_this.transformerList[i].deviceId);
                                }
                                console.log("Transformer Parameters", temptransformerList);
                                if (_this.currentUserData.roleid !== 1) {
                                    _this.getRenewalData();
                                }
                                /* Method For Populating Tiles Count */
                                _this.getMapData(temptransformerList, deviceList);
                                _this.fetchLatestAlertData(temptransformerList);
                                /* Method to Load Profile */
                                _this.loadProfile(temptransformerList);
                                /* Method For Alert Count */
                                var dates = _this.generatesDatesForAlert();
                                var currentDatealert = {
                                    startdate: moment().startOf('month').format('YYYY-MM-DD'),
                                    enddate: moment().endOf('month').format('YYYY-MM-DD')
                                };
                                _this.selectedDurationAlert = _this.durationList[3];
                                //this.alertCount(currentDatealert);
                                /* Method For Weather Load */
                                _this.selectedTransformerForWeather = _this.transformerList[0];
                                _this.selectedTransformerForHealth = _this.transformerList[0];
                                _this.getWeatherData(_this.transformerList[0]);
                                /* Method For Transformer Alert */
                                var currentDate = {
                                    startdate: moment().format('YYYY-MM-DD'),
                                    enddate: moment().format('YYYY-MM-DD')
                                };
                                _this.selectedDuration = _this.durationList[0];
                                // this.getTransformerAlert(currentDate);
                            }
                            else {
                                _this.ngxLoader.stopLoader('dashboard');
                                _this.transformerTile = null;
                                _this.kvaData = null;
                                _this.kwData = null;
                                _this.kwhData = null;
                                _this.dataLoadProfile = [];
                                _this.dataAlertCount = [];
                                _this.mapData = [];
                                _this.selectedTransformerForWeather = null;
                                _this.selectedTransformerForHealth = null;
                                _this.weatherData = null;
                                _this.dataTransformerAlert = [];
                            }
                        }, function (error) {
                            _this.ngxLoader.stopLoader('dashboard');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardComponent.prototype.parameterChange = function (selectedParameter) {
        this.durationSelectionAlert(this.selectedDuration, 'talert');
    };
    DashboardComponent.prototype.changeDateRange = function (event) {
        console.log("event----------", event);
        if (this.showDateRange) {
            var date = {
                startdate: moment(event.value[0]).format('YYYY-MM-DD'),
                enddate: moment(event.value[1]).format('YYYY-MM-DD')
            };
            // this.getTransformerAlert(date);
        }
    };
    DashboardComponent.prototype.changeDateRange1 = function (event) {
        console.log("event----------", event);
        if (this.showDateRange1) {
            var date = {
                startdate: moment(event.value[0]).format('YYYY-MM-DD'),
                enddate: moment(event.value[1]).format('YYYY-MM-DD')
            };
            this.alertCount(date);
        }
    };
    DashboardComponent.prototype.makePayment = function () {
        // You should replace the following URL with your server-side endpoint
        var serverEndpoint = 'makePayment';
        this.http.post(serverEndpoint, {}).subscribe(function (response) {
            // Redirect the user to the payment gateway URL received from the server
            window.location.href = response.paymentUrl;
        }, function (error) {
            console.error('Error making payment:', error);
        });
    };
    DashboardComponent.prototype.durationSelectionAlert = function (selectedDuration, type) {
        console.log('selectedDuration====', selectedDuration);
        var date = {
            startdate: moment().format('YYYY-MM-DD'),
            enddate: moment().format('YYYY-MM-DD')
        };
        if (selectedDuration.id == 2) {
            date.startdate = moment().subtract(1, 'day').format('YYYY-MM-DD');
            date.enddate = moment().subtract(1, 'day').format('YYYY-MM-DD');
        }
        if (selectedDuration.id == 3) {
            date.startdate = moment().startOf('week').format('YYYY-MM-DD');
            date.enddate = moment().endOf('week').format('YYYY-MM-DD');
        }
        if (selectedDuration.id == 4) {
            date.startdate = moment().startOf('month').format('YYYY-MM-DD');
            date.enddate = moment().endOf('month').format('YYYY-MM-DD');
        }
        if (selectedDuration.id == 5) {
            date.startdate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
            date.enddate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
        }
        if (selectedDuration.id == 6 && type === 'talert') {
            this.showDateRange = true;
        }
        else if (type === 'talert') {
            this.showDateRange = false;
        }
        if (selectedDuration.id == 6 && type === 'alert') {
            this.showDateRange1 = true;
        }
        else if (type === 'alert') {
            this.showDateRange1 = false;
        }
        if (type === 'talert' && selectedDuration.id != 6) {
            this.getTransformerAlert(date);
        }
        else if (selectedDuration.id != 6) {
            this.alertCount(date);
        }
    };
    DashboardComponent.prototype.getTransformerAlert = function (date) {
        var _this = this;
        this.dataTransformerAlert = [];
        var temptransformerList = [];
        for (var i = 0; i < this.transformerList.length; i++) {
            temptransformerList.push(this.transformerList[i].transformerid);
        }
        this.ngxLoader.startLoader('dataTransformerAlert');
        this._dashboardService.transformerCount({ daterange: JSON.stringify(date), transformerList: temptransformerList, parameter: this.selectedParameter.value }).subscribe(function (response) {
            console.log("response==getTransformerAlert======", response);
            if (response && response.result && response.result.length > 0) {
                _this.ngxLoader.stopLoader('dataTransformerAlert');
                var count = _.map(response.result, 'count');
                var transformers = _.map(response.result, 'transformerid');
                var sitename = _.map(response.result, 'sitename');
                _this.dataTransformerAlert = [{ x: transformers, y: count, text: sitename, type: 'bar' }];
            }
            else {
                _this.ngxLoader.stopLoader('dataTransformerAlert');
            }
        }, function (error) {
            _this.ngxLoader.stopLoader('dataTransformerAlert');
        });
    };
    DashboardComponent.prototype.generatesDatesForAlert = function () {
        var resultdates = [];
        var n = 7;
        var current = moment();
        while (n > 0) {
            resultdates.push(current.format('YYYY-MM-DD'));
            current.subtract(1, 'day');
            n--;
        }
        console.log("filtered resultdates=============>", resultdates);
        return resultdates;
    };
    DashboardComponent.prototype.alertCount = function (date) {
        var _this = this;
        this.dataAlertCount = [];
        var temptransformerList = [];
        for (var i = 0; i < this.transformerList.length; i++) {
            temptransformerList.push(this.transformerList[i].transformerid);
        }
        this.ngxLoader.startLoader('dataAlertCount');
        this._dashboardService.alertCount({ dates: JSON.stringify(date), transformerList: temptransformerList }).subscribe(function (response) {
            console.log("response=====alertCount===", response);
            if (response && response.result && response.result.length > 0) {
                _this.ngxLoader.stopLoader('dataAlertCount');
                var dataAlercount = response.result;
                var apOverload = _.find(dataAlercount, function (o) {
                    return o.type === 'apOverload';
                });
                var trace1 = {
                    x: apOverload.date,
                    y: apOverload.count,
                    name: 'Overload',
                    type: 'bar'
                };
                var apIunbalance = _.find(dataAlercount, function (o) {
                    return o.type === 'apIunbalance';
                });
                var trace2 = {
                    x: apIunbalance.date,
                    y: apIunbalance.count,
                    name: 'I Unbalance',
                    type: 'bar'
                };
                var apOiltemperature = _.find(dataAlercount, function (o) {
                    return o.type === 'apOiltemperature';
                });
                var trace3 = {
                    x: apOiltemperature.date,
                    y: apOiltemperature.count,
                    name: 'Oil Temperature',
                    type: 'bar'
                };
                var apUnderload = _.find(dataAlercount, function (o) {
                    return o.type === 'apUnderload';
                });
                var trace4 = {
                    x: apUnderload.date,
                    y: apUnderload.count,
                    name: 'Underload',
                    type: 'bar'
                };
                var apLowPowerfactor = _.find(dataAlercount, function (o) {
                    return o.type === 'apLowPowerfactor';
                });
                var trace5 = {
                    x: apLowPowerfactor.date,
                    y: apLowPowerfactor.count,
                    name: 'LowPowerfactor',
                    type: 'bar'
                };
                var apWindingTemperature = _.find(dataAlercount, function (o) {
                    return o.type === 'apWindingTemperature';
                });
                var trace6 = {
                    x: apWindingTemperature.date,
                    y: apWindingTemperature.count,
                    name: 'WindingTemperature',
                    type: 'bar'
                };
                var apOillevel = _.find(dataAlercount, function (o) {
                    return o.type === 'apOillevel';
                });
                var trace7 = {
                    x: apOillevel.date,
                    y: apOillevel.count,
                    name: 'Oillevel',
                    type: 'bar'
                };
                _this.dataAlertCount = [trace1, trace2, trace3, trace4, trace5, trace6, trace7];
                console.log("this.dataAlertCount============", _this.dataAlertCount);
            }
            else {
                _this.ngxLoader.stopLoader('dataAlertCount');
            }
        }, function (error) {
            _this.ngxLoader.stopLoader('dataAlertCount');
        });
    };
    DashboardComponent.prototype.getDeviceStatus = function (transformerList, deviceList) {
        var _this = this;
        this._dashboardService.getDeviceStatus({ "roleid": this.currentUserData.roleid, "transformerlist": transformerList, "deviceList": deviceList }).subscribe(function (response) {
            console.log("response", response.result);
            _this.deviceConnectionStatus = response.result;
            var disconnected = Number(_this.transformerTile.totalTransformer) - Number(response.result.length);
            console.log("response=====>", disconnected, response.result.length);
            _this.deviceStatus(disconnected, response.result.length);
        });
    };
    DashboardComponent.prototype.loadProfile = function (transformerList) {
        var _this = this;
        this.dataLoadProfile = [];
        var finalYaxis = [];
        var sitename = [];
        var xAxis = [];
        var calYaxis = {
            firstrangeVal: 0,
            secondrangeVal: 0,
            thirdrangeVal: 0,
            fourthrangeVal: 0,
            fifthrangeVal: 0
        };
        this._dashboardService.loadProfile({ "transformerlist": transformerList }).subscribe(function (response) {
            console.log('Transformer Data for Rated Load', response);
            if (response && response.code == '1' && response.result.length > 0) {
                _this.transformerDataForHealthIndex = response.result;
                _this.getTranformerHealthIndex(transformerList[0]);
                //     for (let i = 0; i < response.result.length; i++) {
                console.log('loadProfile========', response, "GroupBY==", _.groupBy(response.result, "Deviceid"));
                _.each(_.groupBy(response.result, "sitename"), function (val, key) {
                    sitename.push(key);
                });
                _.each(_.groupBy(response.result, "transformerid"), function (val, key) {
                    xAxis.push(key);
                    if (val.length > 0) {
                        var tempData = 0;
                        for (var i = 0; i < val.length; i++) {
                            var individualObj = JSON.parse(val[i].readings);
                            tempData = (((Number(individualObj.L1) + Number(individualObj.L2) + Number(individualObj.L3)) / 3) / Number(val[i].ratedLoad) * 100);
                            _this.ratedLoadArray.push({ "transformerid": val[i].transformerid, "ratedLoad": val[i].ratedLoad });
                        }
                        _this.LoadPercentages.push({ "transformerid": key, "data": Number(tempData) });
                        finalYaxis.push(tempData);
                    }
                    else {
                        var individualObj = JSON.parse(val[0].readings);
                        finalYaxis.push((((individualObj.L1 + individualObj.L2 + individualObj.L3) / 3) / +val[0].ratedLoad) * 100);
                    }
                });
                /*         for (let i = 0; i < response.result.length; i++) {
                          xAxis.push(response.result[i].transformerid)
                          let individualObj = JSON.parse(response.result[i].readings);
                          finalYaxis.push((((individualObj.L1 + individualObj.L2 + individualObj.L3) / 3)/+response.result[i].ratedLoad)*100);
                          //let individualloadPercentage = (individualObj.L1 + individualObj.L2 + individualObj.L3) / 3
                          //finalYaxis = this.checkRange(individualloadPercentage, calYaxis);
                        } */
                console.log("yaxis=====", finalYaxis);
                //this.dataLoadProfile = [{ x: [20, 40, 60, 80, 100], y: finalYaxis, type: 'bar' }];
                _this.dataLoadProfile = [{ x: xAxis, y: finalYaxis, text: sitename, type: 'bar' }];
                console.log("dataLoadProfile=====", _this.ratedLoadArray);
                /* Method For Populating Tiles Count */
                // this.getTilesCount(response.result);
            }
            else {
            }
        }, function (error) {
            _this.ngxLoader.stopLoader('kvaTile');
            _this.ngxLoader.stopLoader('kwTile');
            _this.ngxLoader.stopLoader('kwhTile');
        });
    };
    DashboardComponent.prototype.checkRange = function (individualloadPercentage, calYaxis) {
        console.log('individualloadPercentage==', individualloadPercentage);
        if (individualloadPercentage >= 0 && individualloadPercentage <= 20) {
            calYaxis.firstrangeVal = calYaxis.firstrangeVal + 1;
        }
        if (individualloadPercentage >= 21 && individualloadPercentage <= 40) {
            calYaxis.secondrangeVal = calYaxis.secondrangeVal + 1;
        }
        if (individualloadPercentage >= 41 && individualloadPercentage <= 60) {
            calYaxis.thirdrangeVal = calYaxis.thirdrangeVal + 1;
        }
        if (individualloadPercentage >= 61 && individualloadPercentage <= 80) {
            calYaxis.fourthrangeVal = calYaxis.fourthrangeVal + 1;
        }
        if (individualloadPercentage >= 81 && individualloadPercentage <= 100) {
            calYaxis.fifthrangeVal = calYaxis.fifthrangeVal + 1;
        }
        console.log('_.toArray(calYaxis)==', _.toArray(calYaxis));
        return _.toArray(calYaxis);
    };
    DashboardComponent.prototype.getTilesCount = function (transformerList) {
        this.ngxLoader.stopLoader('kvaTile');
        this.ngxLoader.stopLoader('kwTile');
        this.ngxLoader.stopLoader('kwhTile');
        this.readings = [];
        /* _.forEach(transformerList, (o: any) => {
           this.readings.push(JSON.parse(o.readings))
         });*/
        this.readings.push(JSON.parse(transformerList[transformerList.length - 1].readings));
        this.kvaData = {
            total: _.sumBy(this.readings, function (o) { return Number(o['3 Phase Apparent Power']); }),
            max: _.maxBy(this.readings, '3 Phase Apparent Power')['3 Phase Apparent Power'],
            min: _.minBy(this.readings, '3 Phase Apparent Power')['3 Phase Apparent Power'],
            range: _.maxBy(this.readings, '3 Phase Apparent Power')['3 Phase Apparent Power'] - _.minBy(this.readings, '3 Phase Apparent Power')['3 Phase Apparent Power'],
            avg: _.sumBy(this.readings, function (o) { return Number(o['3 Phase Apparent Power']); }) / transformerList.length
        };
        this.kwData = {
            total: _.sumBy(this.readings, function (o) { return Number(o['3 Phase Active Power']); }),
            max: _.maxBy(this.readings, '3 Phase Active Power')['3 Phase Active Power'],
            min: _.minBy(this.readings, '3 Phase Active Power')['3 Phase Active Power'],
            range: _.maxBy(this.readings, '3 Phase Active Power')['3 Phase Active Power'] - _.minBy(this.readings, '3 Phase Active Power')['3 Phase Active Power'],
            avg: _.sumBy(this.readings, function (o) { return Number(o['3 Phase Active Power']); }) / transformerList.length
        };
        this.kwhData = {
            total: _.sumBy(this.readings, function (o) { return Number(o['logSystem_Kwh']); }),
            max: _.maxBy(this.readings, 'System_kwh')['System_kwh'],
            min: _.minBy(this.readings, 'System_kwh')['System_kwh'],
            range: _.maxBy(this.readings, 'System_kwh')['System_kwh'] - _.minBy(this.readings, 'System_kwh')['System_kwh'],
            avg: _.sumBy(this.readings, function (o) { return Number(o['System_kwh']); }) / transformerList.length
        };
        console.log("this.kvaData====this.kwData===this.kwhData============", this.kvaData, this.kwData, this.kwhData);
    };
    DashboardComponent.prototype.getMapData = function (transformerList, deviceList) {
        var _this = this;
        console.log("Transformer data", transformerList);
        this.mapData = [];
        this.transformerTile = null;
        this.ngxLoader.startLoader('transformerTile');
        this._dashboardService.transformerTileData({ transformerList: transformerList }).subscribe(function (response) {
            _this.overallTransformerData = response;
            _this.ngxLoader.stopLoader('transformerTile');
            if (response && response.code === '1' && response.result.length > 0) {
                _this.transformerTile = response.dashboardTransformerResult;
                _this.transformerStatusGraph();
                _this.alertStatus();
                _this.getDeviceStatus(transformerList, deviceList);
                _this.lat = response.result[0].siteData.latitude;
                _this.lng = response.result[0].siteData.longitude;
                _this.mapData = _.flatMap(response.result, function (o) {
                    for (var l = 0; l < o.alert.lenght; l++) {
                        if (o.alert[l].parametername == 'apOiltemperature') {
                            _this.oilTempsum = _this.oilTempsum + 1;
                        }
                    }
                    var tempMapData = {};
                    tempMapData.transformerid = o.siteData.transformerid;
                    tempMapData.latitude = o.siteData.latitude;
                    tempMapData.longitude = o.siteData.longitude;
                    tempMapData.sitename = o.siteData.sitename;
                    tempMapData.datareceived = o.datareceived;
                    if (o.datareceived) {
                        var readings = JSON.parse(o.transformerData.readings);
                        tempMapData.Kva = (+readings['3 Phase Apparent Power']).toFixed(2);
                        tempMapData.Kwh = readings.System_kwh;
                        tempMapData.Load = (((readings.L1 + readings.L2 + readings.L3) / 3) / o.transformerData.ratedLoad) * 100;
                    }
                    else if (o.datareceivedafter) {
                        var readings = JSON.parse(o.transformerData.readings);
                        tempMapData.Kva = (+readings['3 Phase Apparent Power']).toFixed(2);
                        tempMapData.Kwh = readings.System_kwh;
                        tempMapData.Load = (((readings.L1 + readings.L2 + readings.L3) / 3) / o.transformerData.ratedLoad) * 100;
                    }
                    else {
                        tempMapData.Kva = null;
                        tempMapData.Kwh = null;
                        tempMapData.Load = null;
                    }
                    tempMapData.alert = _.map(o.alert, function (a) {
                        a.mparametervalue = a.gparametervalue;
                        if (a.parametername === "apOillevel") {
                            if (a.mparametervalue === 4) {
                                a.mparametervalue = "Low";
                            }
                            if (a.mparametervalue === 5) {
                                a.mparametervalue = "Medium";
                            }
                            if (a.mparametervalue === 6) {
                                a.mparametervalue = "High";
                            }
                        }
                        return a;
                    });
                    return tempMapData;
                });
                console.log("overlall data >>>>>>>>>>", _this.overallTransformerData);
                var loadData = _this.overallTransformerData.result;
                var loadDataArray_1 = [];
                var demandArray_1 = [];
                var max_1 = 0;
                var maxdemand_1 = 0;
                var currentDate_1 = moment(moment().format('YYYY-MM-DD HH:mm:ss'));
                var DisconnectedDevices_1 = [];
                loadData.forEach(function (element) {
                    if (element.hasOwnProperty("datareceivedafter")) {
                        DisconnectedDevices_1.push(element.transformerid);
                    }
                    if (element.hasOwnProperty("transformerData")) {
                        var JsonReadings = JSON.parse(element.transformerData.readings);
                        var trafoLoadData = (((Number(JsonReadings.L1) + Number(JsonReadings.L2) + Number(JsonReadings.L3)) / 3) / Number(element.transformerData.ratedLoad) * 100);
                        var demandData = (Number(JsonReadings['3 Phase Active Power']));
                        demandArray_1.push(demandData);
                        loadDataArray_1.push(trafoLoadData);
                        var checkIsOffline = moment(moment(element.transformerData.latestDATE).format('YYYY-MM-DD HH:mm:ss'));
                        var duration = moment.duration(currentDate_1.diff(checkIsOffline));
                        if (duration.minutes() < 20) {
                            if (demandData > maxdemand_1) {
                                maxdemand_1 = demandData;
                                _this.maxDemand = "Transformer ID: " + element.transformerData.transformerid + "[" + element.siteData.sitename + "]";
                            }
                        }
                        if (trafoLoadData > max_1) {
                            max_1 = trafoLoadData;
                            _this.maxTransformerId = "Transformer ID: " + element.transformerData.transformerid + "[" + element.siteData.sitename + "]";
                        }
                        if (element.alert.length >= 3) {
                            var alertData_1 = [];
                            var warningData_1 = " Transformer " + element.transformerid + "[" + element.siteData.sitename + "] is experiencing issues, including ";
                            element.alert.forEach(function (values) {
                                if (!alertData_1.includes(values.parametername))
                                    alertData_1.push(values.parametername);
                            });
                            if (alertData_1.length >= 3) {
                                alertData_1.forEach(function (dataValue) {
                                    warningData_1 += dataValue.replace(/^ap/, '') + ", ";
                                });
                                _this.warningDataArray.push(warningData_1);
                            }
                        }
                    }
                });
                console.log("Disconnected Devices", DisconnectedDevices_1);
                _this.maxDemandValue = maxdemand_1.toFixed(0);
                var sumDemand = demandArray_1.reduce(function (acc, num) { return acc + num; }, 0);
                var count = demandArray_1.filter(function (num) { return num !== 0; }).length;
                _this.averageDemand = Number(sumDemand / count).toFixed(0);
                var sum = loadDataArray_1.reduce(function (acc, num) { return acc + num; }, 0);
                var average = sum / loadDataArray_1.length;
                _this.loadAverageGraph(average.toFixed(1));
                _this.peakLoadGraph(max_1.toFixed(1));
                //this.status(this.mapData[0].transformerid);
            }
        }, function (error) {
            _this.ngxLoader.stopLoader('transformerTile');
        });
    };
    DashboardComponent.prototype.getWeatherData = function (data) {
        var _this = this;
        //let response = JSON.parse('{"coord":{"lon":72.85,"lat":19.01},"weather":[{"id":721,"main":"Haze","description":"haze","icon":"50n"}],"base":"stations","main":{"temp":297.15,"feels_like":297.4,"temp_min":297.15,"temp_max":297.15,"pressure":1013,"humidity":69},"visibility":3500,"wind":{"speed":3.6,"deg":300},"clouds":{"all":20},"dt":1580141589,"sys":{"type":1,"id":9052,"country":"IN","sunrise":1580089441,"sunset":1580129884},"timezone":19800,"id":1275339,"name":"Mumbai","cod":200}');
        var responseWeather;
        this._dashboardService.getWeatherData(data).subscribe(function (response) {
            if (response) {
                console.log("responseWeather==Weather==", response);
                responseWeather = response;
                _this.weatherData = {
                    location: _.startCase(data.locationname),
                    city: _.startCase(data.cityname),
                    state: _.startCase(data.statename),
                    country: _.startCase(data.countryname),
                    temperature: (responseWeather.main.temp - 273.15).toFixed(2),
                    weatherType: responseWeather.weather[0].main,
                    wind: responseWeather.wind.speed * 3.6,
                    humidity: responseWeather.main.humidity,
                };
                console.log("this.weatherData==Weather==", _this.weatherData);
            }
        });
    };
    DashboardComponent.prototype.filters = function (type, param) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filter, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        console.log(type, param);
                        if (!(type === 'date')) return [3 /*break*/, 2];
                        this.timeFilter = param;
                        return [4 /*yield*/, this.formatDate(param)];
                    case 1:
                        filter = _a.sent();
                        //this.filter = this.filter + filter;
                        if (filter.filter === 'This Week' || filter.filter === 'This Month' || filter.filter === 'Last Month') {
                            if (this.filter && this.filter.date) {
                                delete this.filter.date;
                            }
                            this.filter.startDate = filter.startDate;
                            this.filter.endDate = filter.endDate;
                            this.filter.filter = filter.filter;
                        }
                        else if (filter.filter === 'Today' || filter.filter === 'Yesterday') {
                            if (this.filter && this.filter.startDate && this.filter.endDate) {
                                delete this.filter.startDate;
                                delete this.filter.endDate;
                            }
                            this.filter.filter = filter.filter;
                            this.filter.date = filter.date;
                        }
                        else if (filter.filter === 'Custom') {
                            if (this.filter && this.filter.date) {
                                delete this.filter.date;
                            }
                            if (filter.startDate && filter.endDate) {
                                this.filter.startDate = filter.startDate;
                                this.filter.endDate = filter.endDate;
                                this.filter.filter = filter.filter;
                            }
                        }
                        if (filter.startDate && filter.endDate) {
                        }
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log('ERROR:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DashboardComponent.prototype.formatDate = function (param) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (param === 'Today') {
                var d = new Date(), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                resolve({ 'date': [year, month, day].join('-'), 'filter': param });
                // return [year, month, day].join('-');
            }
            else if (param === 'Yesterday') {
                var d = new Date(), month = '' + (d.getMonth() + 1), day = '' + (d.getDate() - 1), year = d.getFullYear();
                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                resolve({ 'date': [year, month, day].join('-'), 'filter': param });
                //return [year, month, day].join('-');
            }
            else if (param === 'Last Month') {
                resolve({ 'startDate': moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), 'endDate': moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), 'filter': param });
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
                // resolve({'startDate':[year, month, day].join('-'), 'endDate':[year, month, 30].join('-')});
            }
            else if (param === 'This Month') {
                resolve({ 'startDate': moment().startOf('month').format('YYYY-MM-DD'), 'endDate': moment().endOf('month').format('YYYY-MM-DD'), 'filter': param });
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
            }
            else if (param === 'This Week') {
                resolve({ 'startDate': moment().startOf('week').format('YYYY-MM-DD'), 'endDate': moment().endOf('week').format('YYYY-MM-DD'), 'filter': param });
                //  resolve('&' + `startDate=${[year, month, startDate].join('-')}` + '&' + `endDate=${[year, month, day].join('-')}` +  '&' + `filter=${param}`);
            }
            else if (param === 'Custom') {
                var dialogConfig = new MatDialogConfig();
                var dialogRef = _this.matDialog.open(CustomDateComponent, {
                    autoFocus: false,
                    height: '350px', width: '450px', data: { "details": "", "action": "Add", selectedDate: _this.customeSelectedDate }
                });
                dialogRef.afterClosed().subscribe(function (value) {
                    console.log("Value=======", value);
                    _this.customeSelectedDate = value;
                    resolve({ 'startDate': value.startDate, 'endDate': value.endDate, 'filter': param });
                });
            }
        });
    };
    DashboardComponent.prototype.getTapPosition = function (transformerid) {
        var _this = this;
        this._dashboardService.getTapPositionData(transformerid).subscribe(function (response) {
            var tap = [];
            for (var j = 1; j < response.result.length; j++) {
                if (response.result[j - 1].Tap_Position != response.result[j].Tap_Position) {
                    tap.push(response.result[j - 1].Tap_Position);
                    console.log("kjsdhfhsuidfu", tap);
                }
                else {
                }
            }
            _this.counter = tap.length + 1;
        });
    };
    DashboardComponent.prototype.loadLeafletMap = function () {
        var _this = this;
        if (this.map) {
            this.map.remove();
        }
        this.map = L.map('leafletMap', { fullscreenControl: true }).setView([this.lat1, this.lng1], 4);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '©Bola'
        }).addTo(this.map);
        this.map.attributionControl.setPrefix(false);
        // this.map.attributionControl.remove();
        this.mapData.forEach(function (data) {
            var icon = L.icon({
                iconUrl: data.datareceived && data.alert.length === 0
                    ? _this.greenTransformerPath
                    : data.datareceived && data.alert.length > 0
                        ? _this.redTransformerPath
                        : _this.blackTransformerPath,
                iconSize: [30, 30],
                iconAnchor: [15, 30]
            });
            var marker = L.marker([data.latitude, data.longitude], { icon: icon }).addTo(_this.map);
            var popupContent = "\n      <p><strong>Transformer Id:</strong> " + data.transformerid + "</p>\n      <p><strong>Site Name:</strong> " + data.sitename + "</p>\n      " + (data.datareceived
                ? '<p style="color:green;">Power: On</p>'
                : '<p style="color:red;">Power: Off</p>') + "\n      " + (data.alert.length > 0
                ? '<p style="color:red;">' + data.alert.map(function (param) { return param.parametername.slice(2) + ": " + param.mparametervalue; }).join('<br>') + '</p>'
                : '') + "\n    ";
            marker.bindTooltip(popupContent, {
                direction: 'top',
                sticky: true,
                opacity: 1.8
            });
            marker.on('click', function () {
                _this.transformerClicked(data);
            });
        });
    };
    DashboardComponent.prototype.getTranformerHealthIndex = function (transformerID) {
        var _this = this;
        this.status(transformerID);
        this.getTapPosition(transformerID);
        this.oilTempValues = 0;
        this.windingTempValues = 0;
        this.oilLevelValues = 0;
        this.healthOfTransformer = 0;
        this.loadPercentageValue = 0;
        this.oilLevelIndicator = '0';
        var OilTempDataGraph = [];
        var windTempDataGraph = [];
        var OilLevelDataGraph = [];
        var ambeintDataGraph = [];
        var loadGraphData = [];
        var allGraphDate = [];
        this._dashboardService.getTransformerHealthIndex(transformerID).subscribe(function (response) {
            for (var i = 0; i < _this.LoadPercentages.length; i++) {
                if (_this.LoadPercentages[i].transformerid == transformerID) {
                    _this.loadPercentageValue = Number(_this.LoadPercentages[i].data).toFixed(2);
                    loadGraphData.push(Number(_this.LoadPercentages[i].data).toFixed(2));
                    if (isNaN(_this.loadPercentageValue)) {
                        _this.loadPercentageValue = 0;
                    }
                }
            }
            /*this.chart3.updateOptions({
              series: [
                this.loadPercentageValue
              ]
            });*/
            _this._dashboardService.parameterConfig(transformerID).subscribe(function (response1) {
                var oilTempDataFlag = false;
                var oilLevelDataFlag = false;
                var lugTempDataFlag = false;
                if (response1.result.length > 0) {
                    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>Test Data", _this.transformerDataForHealthIndex);
                    for (var i = 0; i < _this.transformerDataForHealthIndex.length; i++) {
                        if (_this.transformerDataForHealthIndex[i].transformerid == transformerID) {
                            if (response1.result[0].oiltemperature == '1') {
                                _this.oilTempValues = _this.transformerDataForHealthIndex[i].Oil_Temperature;
                                _this.ambeintTempValues = _this.transformerDataForHealthIndex[i].Ambient_Temperature;
                                OilTempDataGraph.push(_this.transformerDataForHealthIndex[i].Oil_Temperature);
                                allGraphDate.push(_this.transformerDataForHealthIndex[i].date);
                                var dateString = _this.transformerDataForHealthIndex[i].DATE;
                                /* this.chart1.updateOptions({
                                   series: [
                                     this.transformerDataForHealthIndex[i].Oil_Temperature
                                    ]
                                 })*/
                                oilTempDataFlag = true;
                            }
                            if (response1.result[0].lugtemp == '1') {
                                var data = JSON.parse(_this.transformerDataForHealthIndex[i].readings);
                                lugTempDataFlag = true;
                            }
                            if (response1.result[0].windingtemperature == '1') {
                                if (_this.transformerDataForHealthIndex[i].hasOwnProperty("Winding_Temperature")) {
                                    _this.windingTempValues = _this.transformerDataForHealthIndex[i].Winding_Temperature;
                                    windTempDataGraph.push(_this.transformerDataForHealthIndex[i].Winding_Temperature);
                                }
                            }
                            if (_this.transformerDataForHealthIndex[i].Winding_Temperature < 0) {
                                _this.windingTempValues = 0;
                            }
                            if (response1.result[0].oillevel == '1') {
                                if (_this.transformerDataForHealthIndex[i].Oil_Level == 4) {
                                    _this.oilLevelValues = 20;
                                    _this.oilLevelIndicator = "LOW";
                                }
                                else if (_this.transformerDataForHealthIndex[i].Oil_Level == 5) {
                                    _this.oilLevelValues = 50;
                                    _this.oilLevelIndicator = "MEDIUM";
                                }
                                else if (_this.transformerDataForHealthIndex[i].Oil_Level == 6) {
                                    _this.oilLevelValues = 90;
                                    _this.oilLevelIndicator = "HIGH";
                                }
                                else {
                                    _this.oilLevelIndicator = _this.transformerDataForHealthIndex[i].Oil_Level + '%';
                                    _this.oilLevelValues = Number(_this.transformerDataForHealthIndex[i].Oil_Level);
                                }
                                // this.UpdateOilLevelGraph(this.oilLevelValues,this.oilLevelIndicator);
                                oilLevelDataFlag = true;
                                OilLevelDataGraph.push(Number(_this.transformerDataForHealthIndex[i].Oil_Level));
                            }
                            if (response1.result[0].windingtemperaturebycal == '1') {
                                if (_this.transformerDataForHealthIndex[i].Oil_Temperature !== 0 && _this.windingTempValues == 0) {
                                    var jsonReadings = JSON.parse(_this.transformerDataForHealthIndex[i].readings);
                                    var addition = Number(jsonReadings.L1) + Number(jsonReadings.L2) + Number(jsonReadings.L3);
                                    var LoadPercentage = ((addition / 3) / Number(_this.transformerDataForHealthIndex[i].kvarating)) * 100;
                                    _this.windingTempValues = Number((Number(_this.transformerDataForHealthIndex[i].Oil_Temperature) + ((_this.transformerDataForHealthIndex[i].kwhreading * LoadPercentage) / 100)).toFixed(2));
                                    windTempDataGraph.push(_this.windingTempValues);
                                    if (isNaN(_this.windingTempValues)) {
                                        _this.windingTempValues = 0;
                                    }
                                }
                            }
                            if (_this.currentUserData.userid == 233) {
                                _this.updateAllComparisionGraph({ oil: OilTempDataGraph, wind: windTempDataGraph, date: allGraphDate });
                            }
                        }
                    }
                    _this.hotSpotCalculation();
                    var color_1 = '#008000';
                    if (_this.windingTempValues > 105) {
                        color_1 = '#FF0000';
                    }
                    /*this.chart2.updateOptions({
                     
                      series: [
                        this.windingTempValues
                      ],
                      colors:[color]
                    });*/
                    console.log("Calculated Winding Tempareture value", _this.calculatedWindingTemprature);
                    if (response.data.length > 0) {
                        _this.healthOfTransformer = response.data[0].percentage;
                        _this.dataforHealthIndex = response.data[0].alldata;
                        if (_this.healthOfTransformer >= 85) {
                            _this.healthColor = "green";
                        }
                        else if (_this.healthOfTransformer < 85 && _this.healthOfTransformer >= 70) {
                            _this.healthColor = "orange";
                        }
                        else if (_this.healthOfTransformer < 70) {
                            _this.healthColor = "red";
                        }
                        /* this.healthIndexObject.updateOptions({
                           series: [
                             this.healthOfTransformer
                           ]
                         });*/
                    }
                }
                /*if(!oilTempDataFlag){
                  this.chart1.updateOptions({
                    series: [
                     0
                    ]
                  });
                }*/
                if (!oilLevelDataFlag) {
                    _this.UpdateOilLevelGraph(0, "No Data");
                }
            });
        });
    };
    DashboardComponent.prototype.updateAllComparisionGraph = function (data) {
        console.log(">/???////////", data);
        this.comparision.updateOptions({
            series: [
                { data: data.oil },
                { data: data.wind }
            ]
        });
    };
    DashboardComponent.prototype.UpdateOilLevelGraph = function (value, label) {
        var color = '#008000';
        if (value < 25) {
            color = '#FF0000';
        }
        else if (value > 60) {
            color = '#FFA500';
        }
        this.oilLevelGraphObject.updateOptions({
            series: [
                value
            ],
            plotOptions: {
                radialBar: {
                    dataLabels: {
                        value: {
                            formatter: function (val, opts) {
                                return label; // Use the updated oilLevelIndicator
                            }
                        }
                    }
                }
            },
            colors: [color]
        });
    };
    DashboardComponent.prototype.updateLugTempGraph = function (data) {
        console.log(data);
        this.lugTempGraphObject.updateOptions({
            series: [
                data.Lug_Temp_R, data.Lug_Temp_Y, data.Lug_Temp_B
            ],
            plotOptions: {
                radialBar: {
                    dataLabels: {
                        value: {
                            formatter: function (seriesName, opts) {
                                return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "°C";
                            }
                        }
                    }
                }
            }
        });
    };
    DashboardComponent.prototype.transformerSelectionWeather = function (selectedTransformer) {
        if (this.selectedTransformerForWeather) {
            this.getWeatherData(selectedTransformer);
        }
    };
    DashboardComponent.prototype.getLastUpdatedAlertsData = function () {
        var _this = this;
        this._dashboardService.getLastUpdatedAlertsData({
            userid: this.currentUserData.userid,
            roleid: this.currentUserData.roleid
        }).subscribe(function (response) {
            console.log("live alerts", response);
            console.log("Expired Transformer", _this.amcexpiredtransformer);
            if (response.result.length > 0) {
                // filter out expired transformer IDs before pushing
                var filteredData = response.result.filter(function (item) { return !_this.amcexpiredtransformer.includes(item.transformerid); } // ignore expired ones
                );
                _this.latestAlertsArray = _this.latestAlertsArray.concat(filteredData);
            }
        });
    };
    DashboardComponent.prototype.popupTable = function (state, selected) {
        var _this = this;
        console.log('data==edit==', state);
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = '80%';
        dialogConfig.width = '70%';
        console.log("gyugyuyugyggi--hgjhhghh", this.overallTransformerData);
        if (this.overallTransformerData !== undefined) {
            if (state == 'Disconnected') {
                this.overallTransformerData.result.forEach(function (itemA) {
                    // Check if there is a match in `deviceConnectionStatus`
                    var isMatched = _this.deviceConnectionStatus.some(function (itemB) { return itemA.transformerid == itemB.id; });
                    if (isMatched) {
                        console.log("itemA.transformerid", itemA.transformerid);
                        itemA.deviceStatus = false;
                    }
                });
            }
            if (state == 'Connected') {
                this.overallTransformerData.result.forEach(function (itemA) {
                    // Check if there is a match in `deviceConnectionStatus`
                    var isMatched = _this.deviceConnectionStatus.some(function (itemB) { return itemA.transformerid == itemB.id; });
                    if (!isMatched) {
                        console.log("itemA.transformerid", itemA.transformerid);
                        itemA.deviceStatusConnected = true;
                    }
                });
            }
            if (state == 'Healthy') {
                this.overallTransformerData.result.forEach(function (itemA) {
                    // Check if there is a match in `deviceConnectionStatus`
                    var isMatched = _this.Healthy.some(function (itemB) { return itemA.transformerid == itemB; });
                    if (isMatched) {
                        console.log("itemA.transformerid", itemA.transformerid);
                        itemA.healthStatus = true;
                    }
                });
            }
            if (state == 'Average') {
                this.overallTransformerData.result.forEach(function (itemA) {
                    // Check if there is a match in `deviceConnectionStatus`
                    var isMatched = _this.averageHealth.some(function (itemB) { return itemA.transformerid == itemB; });
                    if (isMatched) {
                        console.log("itemA.transformerid", itemA.transformerid);
                        itemA.AvghealthStatus = true;
                    }
                });
            }
            if (state == 'Unhealthy') {
                this.overallTransformerData.result.forEach(function (itemA) {
                    // Check if there is a match in `deviceConnectionStatus`
                    var isMatched = _this.Unhealthy.some(function (itemB) { return itemA.transformerid == itemB; });
                    if (isMatched) {
                        console.log("itemA.transformerid", itemA.transformerid);
                        itemA.UnhealthStatus = true;
                    }
                });
            }
            if (state == 'completeMaintenance') {
                this.overallTransformerData.result.forEach(function (itemA) {
                    // Check if there is a match in `deviceConnectionStatus`
                    var isMatched = _this.completeMaintenanceData.some(function (itemB) { return itemA.transformerid == itemB; });
                    if (isMatched) {
                        console.log("itemA.transformerid", itemA.transformerid);
                        itemA.completeMaintenanceStatus = true;
                    }
                });
            }
            if (state == 'pendingMaintenance') {
                this.overallTransformerData.result.forEach(function (itemA) {
                    // Check if there is a match in `deviceConnectionStatus`
                    var isMatched = _this.pendingMaintenanceData.some(function (itemB) { return itemA.transformerid == itemB; });
                    if (isMatched) {
                        console.log("itemA.transformerid", itemA.transformerid);
                        itemA.pendingMaintenanceStatus = true;
                    }
                });
            }
            dialogConfig.data = {
                type: state,
                currentUserData: this.currentUserData,
                TransformerData: this.overallTransformerData
            };
            if (selected == "alertDataSelected") {
                dialogConfig.data['selected'] = selected;
            }
            if (selected == "helathCenterDataSelected") {
                dialogConfig.data['selected'] = selected;
            }
            var dialogRef = this.matDialog.open(PopuptableComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(function (response) {
            });
        }
    };
    DashboardComponent.prototype.popupAlertsTable = function () {
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = '90%';
        dialogConfig.width = '90%';
        dialogConfig.data = {
            type: "AlertsTable",
            currentUserData: this.currentUserData,
        };
        this.dialogRefas = this.matDialog.open(AlertpopuptableComponent, dialogConfig);
    };
    DashboardComponent.prototype.status = function (transformerid) {
        var _this = this;
        this.mapData.forEach(function (data) {
            if (transformerid == data.transformerid) {
                console.log("Inside data", data);
                if (data.datareceived && data.alert.length == 0) {
                    _this.imgPath = _this.greenTransformerPath;
                    _this.batteryStatusImgUrl = "assets/images/fullbattery.png";
                }
                else if (data.datareceived && data.alert.length > 0) {
                    _this.imgPath = _this.redTransformerPath;
                    _this.batteryStatusImgUrl = "assets/images/fullbattery.png";
                    console.log("b./////////./.");
                }
                else {
                    _this.imgPath = _this.blackTransformerPath;
                    _this.batteryStatusImgUrl = "assets/images/lowbattery.png";
                }
                if (data.Kwh === "000") {
                    _this.imgPath = _this.blackTransformerPath;
                    _this.batteryStatusImgUrl = "assets/images/fullbattery.png";
                }
            }
        });
    };
    DashboardComponent.prototype.open_individual = function (TransformerID) {
        // console.log(TransformerID)
        // this.router.navigate(['/#/individual-status/', { transformerId: TransformerID} ]);
        this.router.navigate(['digitalTwin/'], { queryParams: { transformerId: TransformerID } });
    };
    DashboardComponent.prototype.getRenewalData = function () {
        var _this = this;
        console.log("getRenewalData called", this.allTransformers);
        this._dashboardService.getRenewalDate(this.currentUserData.userid).subscribe(function (response) {
            if (response.result.length > 0) {
                var expiredList = _this.allTransformers.filter(function (t) { return t.amc_status === "Expired" || t.dashboard_access === 0; });
                var activeList = _this.allTransformers.filter(function (t) { return t.amc_status !== "Expired" && t.dashboard_access !== 0; });
                if (expiredList.length > 0) {
                    if (activeList.length === 0) {
                        var domObject = document.getElementById("denyDashboardAccess");
                        domObject.style.opacity = '0.0';
                        _this.matDialog.open(RenewalWindowComponent, {
                            autoFocus: false,
                            height: '85%',
                            width: '50%',
                            data: { data: response.result, amount: _this.transformerList },
                            disableClose: true,
                            panelClass: 'custom-dialog-container'
                        });
                    }
                    else {
                        _this.matDialog.open(RenewalWindowComponent, {
                            autoFocus: false,
                            height: '85%',
                            width: '50%',
                            data: { data: response.result, amount: _this.allTransformers },
                            disableClose: false,
                            panelClass: 'custom-dialog-container'
                        });
                    }
                }
                // ✅ Case 3: sabhi active → kuch nahi karna
            }
        });
    };
    DashboardComponent.prototype.hotSpotCalculation = function () {
        var oilTempRise = Number(this.oilTempValues) * (1.2) * 0.9;
        var hotspotGradient = 15 * (1.2) * 0.9;
        var ambientTemp = this.ambeintTempValues;
        this.hotSpotCalculationValue = Number(ambientTemp + oilTempRise + hotspotGradient).toFixed(2);
        console.log("temp Hotspot calc/[[[[[", this.hotSpotCalculationValue);
    };
    return DashboardComponent;
}());
export { DashboardComponent };
